/* ─── Root ─── */

.root {
  list-style: none;
  padding: 0;
  margin: 0;
  font-family: var(--font-sans);
}

/* ─── Item ─── */

.item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: 3rem;
  padding: var(--space-2) var(--space-4);
  color: var(--md-on-surface);
}

.item.twoLine {
  min-height: 3.5rem;
  align-items: flex-start;
}

.root[data-dense] .item {
  min-height: 2.5rem;
}

.root[data-dense] .item.twoLine {
  min-height: 3rem;
}

/* ─── Slots ─── */

.leading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  flex-shrink: 0;
  color: var(--md-on-surface-variant);
}

.text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.primary {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  color: var(--md-on-surface);
}

.secondary {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  color: var(--md-on-surface-variant);
}

.primary,
.secondary {
  overflow: hidden;
  text-overflow: ellipsis;
}

.trailing {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--md-on-surface-variant);
}

.leading > svg,
.trailing > svg {
  width: 1em;
  height: 1em;
  font-size: var(--icon-size-lg);
}

/* ─── Item button wrapper ─── */

.itemButtonWrapper {
  list-style: none;
}

.itemButtonWrapper.withAction {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  padding-inline-end: var(--space-2);
}

.itemButtonWrapper.withAction > .itemButton {
  flex: 1;
  min-width: 0;
}

.action {
  display: flex;
  flex-shrink: 0;
}

/* ─── Item button ─── */

.itemButton {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  min-height: 3rem;
  padding: var(--space-2) var(--space-4);
  font-family: inherit;
  font-size: inherit;
  color: var(--md-on-surface);
  background: transparent;
  border: none;
  text-align: start;
  text-decoration: none;
  cursor: pointer;
  position: relative;
}

.itemButton::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

.itemButton.twoLine {
  min-height: 3.5rem;
  align-items: flex-start;
}

.root[data-dense] .itemButton {
  min-height: 2.5rem;
}

.root[data-dense] .itemButton.twoLine {
  min-height: 3rem;
}

@media (hover: hover) {
  .itemButton:hover::before {
    opacity: var(--state-hover);
  }
}

.itemButton[data-selected] {
  background: var(--md-primary-container);
  color: var(--md-on-primary-container);
}

.itemButton[aria-disabled="true"] {
  opacity: 0.38;
  cursor: not-allowed;
  pointer-events: none;
}

/* ─── Subheader ─── */

.subheader {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-weight: 600;
  color: var(--md-on-surface-variant);
  padding: var(--space-4) var(--space-4) var(--space-1);
}

/* ─── Divider ─── */

.divider {
  height: 0;
  border: none;
  border-block-start: 1px solid var(--md-outline-variant);
  margin: 0;
}

.inset {
  margin-inline-start: calc(var(--space-4) + 2.5rem + var(--space-3));
}
